import {
  setNewFunnelUrlPattern,
  setNewHeatmapUrlPattern,
  setRecordingsOverviewPageUrlFilterValue,
} from '@va/dashboard/actions/ui';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';

export const usePageUrlActions = (pageUrl: string) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const openInNewTab = useCallback(() => window.open(pageUrl, '_blank'), [pageUrl]);

  const viewPages = useCallback(() => {
    history.push('/dashboard/pages', { pageUrl });
  }, [history, pageUrl]);

  const createHeatmap = useCallback(() => {
    dispatch(setNewHeatmapUrlPattern(pageUrl));
    history.push('/behaviour/heatmaps/create', { from: history.location.pathname });
  }, [dispatch, history, pageUrl]);

  const createFunnel = useCallback(() => {
    dispatch(setNewFunnelUrlPattern(pageUrl));
    history.push('/behaviour/funnels/create');
  }, [dispatch, history, pageUrl]);

  const viewRecordings = useCallback(() => {
    dispatch(setRecordingsOverviewPageUrlFilterValue(pageUrl));
    history.push('/behaviour/recordings');
  }, [dispatch, history, pageUrl]);

  const viewCustomEvents = useCallback(() => {
    history.push('/behaviour/event-tracking/manual', { pageUrl });
  }, [history, pageUrl]);

  const viewVisitors = useCallback(() => {
    history.push('/visitors/latest', { pageUrl });
  }, [history, pageUrl]);

  return { openInNewTab, viewPages, createHeatmap, createFunnel, viewRecordings, viewCustomEvents, viewVisitors };
};
